module.exports = __webpack_public_path__ + "static/media/custom_menu.a8a139dc.svg";